import { EventContext, Fields } from '@vimeo/bigpicture-client';

export const commentBpContextName = 'comment_context';
export const commentBpContextSchemaVersion = 3;
export type CommentBpContext = Fields<
  typeof commentBpContextName,
  typeof commentBpContextSchemaVersion
>;

export const buildCommentBpContext = (fields: CommentBpContext) => {
  return {
    comment_context: new EventContext(commentBpContextName, commentBpContextSchemaVersion, {
      ...fields,
    }),
  };
};
